import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withVDSManager, calculateRem } from '@vds-core/utilities';
import { LayoutTokens } from '@vds-tokens/layout';
import { spacingForButton, spacingForTextLink, spacingForTextLinkCaret } from '../util/spacingUtil';
import ButtonGroupItem from './ButtonGroupItem';
var _calculateButtonSpacing = function _calculateButtonSpacing(size, use, nextButtonType) {
  var isButton = use === 'primary' || use === 'secondary';
  var spacings = isButton ? spacingForButton(nextButtonType, size) : use === 'textLink' ? spacingForTextLink(nextButtonType, size) : spacingForTextLinkCaret(nextButtonType);
  return spacings;
};
var _calculateRowSpacing = function _calculateRowSpacing(rowData, nextRowData) {
  var spacing;
  var rowHas = function rowHas(data, type) {
    return data && data.find(function (obj) {
      return obj.use === type;
    });
  };
  var getSize = function getSize(data) {
    return data && data.size;
  };
  var rowButtonObj = rowHas(rowData, 'primary') || rowHas(rowData, 'secondary');
  var nextRowButtonObj = rowHas(nextRowData, 'primary') || rowHas(nextRowData, 'secondary');
  var rowTextLinkCaretObj = rowHas(rowData, 'textLinkCaret');
  var nextRowTextLinkCaretObj = rowHas(nextRowData, 'textLinkCaret');
  var rowTextLinkObj = rowHas(rowData, 'textLink');
  if (rowButtonObj) {
    if (getSize(rowButtonObj) === 'small') {
      spacing = nextRowButtonObj ? '3X' : '6X';
    } else {
      spacing = nextRowButtonObj ? '3X' : nextRowTextLinkCaretObj ? '6X' : '4X';
    }
  } else if (rowTextLinkCaretObj) {
    spacing = '6X';
  } else if (rowTextLinkObj) {
    if (getSize(rowTextLinkObj) === 'small') {
      spacing = nextRowButtonObj ? '6X' : '8X';
    } else {
      spacing = nextRowButtonObj ? '4X' : '6X';
    }
  }
  return spacing;
};
var _getButtonWrapperWidth = function _getButtonWrapperWidth(size, width) {
  return width;
};
var propTypes = {
  /**
   * @ignore
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.oneOf(['small', 'large']),
    use: PropTypes.oneOf(['primary', 'secondary', 'textLink', 'textLinkCaret']),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    surface: PropTypes.oneOf(['light', 'dark']),
    href: PropTypes.string,
    ariaLabel: PropTypes.string,
    width: PropTypes.string,
    'data-analyticstrack': PropTypes.string,
    'data-track': PropTypes.string,
    'data-track-ignore': PropTypes.string,
    'data-clickstream': PropTypes.string
  })),
  /**
   * If provided, width of Button components will be rendered based on this value. If omitted, default button widths are rendered.
   */
  childWidth: PropTypes.string,
  /**
   * If provided, aligns TextLinks alignment when rowQuantity is set one.
   */
  alignment: PropTypes.oneOf(['left', 'right', 'center']),
  /**
   * @ignore extended viewports for 3.x only
   * An object containing number of Button components per row, in each viewport
   */
  rowQuantity: PropTypes.shape({
    mobile: PropTypes.number,
    mobileLarge: PropTypes.number,
    tablet: PropTypes.number,
    tabletLarge: PropTypes.number,
    desktop: PropTypes.number
  }),
  /**
   * @ignore extended viewports for 3.x only
   * Viewport the Buttons will be rendered in
   */
  viewport: PropTypes.oneOf(['desktop', 'tabletLarge', 'tablet', 'mobileLarge', 'mobile']),
  /**
   * @ignore
   * No vertical padding
   */
  noVerticalPadding: PropTypes.bool,
  /**
  * @ignore 
   If provided, the provided function will determine the spacing between buttons
  */
  calculateButtonSpacing: PropTypes.func,
  /**
  * @ignore
   If provided a max width of the provided string will be rendered.
  */
  maxWidth: PropTypes.string,
  /**
  * @ignore
   If provided a new Button component will render
  */
  renderButton: PropTypes.func,
  /**
   * @ignore
   */
  dataLoc: PropTypes.string,
  /**
   * @ignore
   */
  width: PropTypes.string,
  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),
  /**
   * @ignore
   */
  getButtonWrapperWidth: PropTypes.func
};
var defaultProps = {
  viewport: 'desktop',
  noVerticalPadding: false,
  maxWidth: undefined,
  calculateButtonSpacing: _calculateButtonSpacing,
  getButtonWrapperWidth: _getButtonWrapperWidth,
  calculateRowSpacing: _calculateRowSpacing,
  surface: 'light',
  childWidth: 'auto',
  alignment: 'center'
};
var ButtonGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ButtonGroupWrapper",
  componentId: "VDS__sc-lt36ab-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: ", ";\n"])), function (_ref) {
  var maxWidth = _ref.maxWidth,
    rowQuantity = _ref.rowQuantity;
  return rowQuantity !== 1 && maxWidth;
}, function (_ref2) {
  var width = _ref2.width;
  return width ? width : '100%';
});
var ButtonGroupRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "ButtonGroupRow",
  componentId: "VDS__sc-lt36ab-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  padding-bottom: ", ";\n  justify-content: ", ";\n"])), function (_ref3) {
  var spacing = _ref3.spacing,
    totalGroupItems = _ref3.totalGroupItems;
  return totalGroupItems > 1 && spacing ? calculateRem(LayoutTokens.space[spacing].value) : 0;
}, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment;
});
var ButtonGroup = /*#__PURE__*/function (_Component) {
  _inherits(ButtonGroup, _Component);
  var _super = _createSuper(ButtonGroup);
  function ButtonGroup() {
    var _this;
    _classCallCheck(this, ButtonGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e, childClick) {
      childClick && childClick(e);
      _this.props.onClick && _this.props.onClick(e);
    });
    _defineProperty(_assertThisInitialized(_this), "_calculateWidth", function (childWidth, maxWidth, rowQuantityVal) {
      var width;
      var maximum = parseInt(maxWidth);
      if (_this.props.width) return _this.props.width;
      if (childWidth && rowQuantityVal) {
        if (childWidth[childWidth.length - 1] === '%') {
          width = parseInt(childWidth) / 100;
          width = 596 * width;
        } else {
          width = parseInt(childWidth) * rowQuantityVal;
        }
        width = width < maximum ? calculateRem(width) : calculateRem(maximum);
      } else {
        width = calculateRem(maximum);
      }
      return width;
    });
    _defineProperty(_assertThisInitialized(_this), "_getRowQuantityValue", function (rowQuantityObj) {
      var viewport = _this.props.viewport;
      if (viewport === 'mobileLarge' && !rowQuantityObj[viewport]) {
        return rowQuantityObj['mobile'];
      } else if (viewport === 'tabletLarge' && !rowQuantityObj[viewport]) {
        return rowQuantityObj['tablet'];
      } else {
        return rowQuantityObj[viewport];
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderButtonGroupRows", function (rowQuantityVal) {
      var _this$props = _this.props,
        data = _this$props.data,
        calculateRowSpacing = _this$props.calculateRowSpacing,
        alignment = _this$props.alignment;
      var groupedData = [];
      for (var i = 0; i < data.length; i += rowQuantityVal) {
        var chunk = data.slice(i, i + rowQuantityVal);
        groupedData.push(chunk);
      }
      return /*#__PURE__*/React.createElement(Fragment, null, groupedData.map(function (rowData, index) {
        var nextRowData = index < groupedData.length - 1 && groupedData[index + 1];
        return /*#__PURE__*/React.createElement(ButtonGroupRow, {
          key: index,
          alignment: alignment,
          totalGroupItems: data.length,
          spacing: calculateRowSpacing(rowData, nextRowData)
        }, _this.renderButtonGroupItems(rowData, rowQuantityVal));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderButtonGroupItems", function (buttonData, rowQuantityVal) {
      var _this$props2 = _this.props,
        childWidth = _this$props2.childWidth,
        calculateButtonSpacing = _this$props2.calculateButtonSpacing,
        renderButton = _this$props2.renderButton,
        dataLoc = _this$props2.dataLoc,
        surface = _this$props2.surface,
        getButtonWrapperWidth = _this$props2.getButtonWrapperWidth;
      return /*#__PURE__*/React.createElement(Fragment, null, buttonData.map(function (child, index) {
        var children = child.children,
          size = child.size,
          use = child.use,
          width = child.width,
          noVerticalPadding = child.noVerticalPadding,
          ariaLabel = child.ariaLabel;
        var btnWidth = width ? width : childWidth;
        var groupWidth = getButtonWrapperWidth(size, btnWidth);
        var nextButtonType = index < buttonData.length - 1 ? buttonData[index + 1].use : undefined;
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement(ButtonGroupItem, _extends({}, child, {
          ariaLabel: ariaLabel,
          children: children,
          rowQuantity: rowQuantityVal,
          size: size,
          use: use,
          width: btnWidth,
          onClick: function onClick(e) {
            return _this._onClick(e, child.onClick);
          },
          index: index,
          noVerticalPadding: noVerticalPadding,
          calculateButtonSpacing: calculateButtonSpacing,
          nextButtonType: nextButtonType,
          renderButton: renderButton,
          dataLoc: dataLoc,
          groupWidth: groupWidth,
          surface: surface
        })));
      }));
    });
    return _this;
  }
  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        data = _this$props3.data,
        childWidth = _this$props3.childWidth,
        rowQuantityProp = _this$props3.rowQuantity,
        maxWidth = _this$props3.maxWidth,
        className = _this$props3.className,
        width = _this$props3.width;
      var rowQuantityVal = rowQuantityProp && this._getRowQuantityValue(rowQuantityProp);
      return /*#__PURE__*/React.createElement(ButtonGroupWrapper, {
        maxWidth: this._calculateWidth(childWidth, maxWidth, rowQuantityVal),
        rowQuantity: rowQuantityVal,
        className: className,
        width: width
      }, rowQuantityVal ? this.renderButtonGroupRows(rowQuantityVal) : this.renderButtonGroupItems(data, rowQuantityVal));
    }
  }]);
  return ButtonGroup;
}(Component);
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/** @component */
export default withVDSManager(ButtonGroup, true);